export default __webpack_public_path__ + "media/images/icons/external-link-29c9e42cac839a913295b5feb8fcf84a.svg";